module.exports = __webpack_public_path__ + "images/category_lp/musical_instrument/new/mainBg_4bbc797f0e798bc854be5a9e7c0667d0.jpg";